module.exports = __webpack_public_path__ + "img/chargingstation-inprogress.b52c5987.svg";